import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { Bottom, Label, Date, CardNewsContainer } from './style';
import { Cover, Description, Overlay, Title } from '../style';
import CTA from '../../CTA';
import Text from '../../Text';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import HtmlRaw from '../../HtmlRaw';
// eslint-disable-next-line import/no-cycle

const CardNews = ({ item, onClick, className = '', mediaIsPhone }) => {
  const [data, setData] = useState(item);

  useEffect(() => {
    setData(item);
  }, [item]);

  const handleOnClick = () => {
    if (onClick) onClick();
  };

  return (
    <CardNewsContainer className={`news ${className}`}>
      <Cover cover={data?.cover} onClick={handleOnClick} className="card-cover">
        <Overlay>
          <Label>
            {data?.categories?.length > 0 && data?.categories[0]?.name}
          </Label>
          <Label>
            {data?.categories?.length > 0 && data?.categories[0]?.name}
          </Label>
        </Overlay>
      </Cover>
      <Bottom className="bottom">
        <Date>{dayjs(data.publication_from * 1000).format('DD/MM/YYYY')}</Date>
        <Title className="news title" onClick={handleOnClick}>
          <Text type="h3" className="link">
            {data?.title}
          </Text>
        </Title>
        <Description className="description">
          <HtmlRaw html={data?.body} />
        </Description>
        <CTA
          onClick={handleOnClick}
          btnText="Dettaglio"
          type={mediaIsPhone ? 'primary' : 'tertiary'}
          icon={!mediaIsPhone ? 'arrow-narrow-right' : ''}
          bottomRight
        />
      </Bottom>
    </CardNewsContainer>
  );
};

CardNews.propTypes = {
  mediaIsPhone: PropTypes.bool,
  className: PropTypes.string,
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  // HOC (connect, state)
};

export default connect((state) => ({}))(withMediaQueries(CardNews));
